import React, { useCallback } from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { ProductHeader } from '@app/features';
import { ProductList, ProductDeleteModal, ProductCreate, ProductUpdate } from '@app/features/Product';
import { useResourceScreenHelpers } from '@app/hooks';
import { productApi } from '@app/store';
import { IProduct } from '@app/common';
import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@app/types';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const ProductScreen = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'ProductScreen'>>();

  const [readOne, { isFetching }] = productApi.useLazyReadOneProductQuery();
  const [deleteOne, { isLoading }] = productApi.useDeleteOneProductsMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: product } = useResourceScreenHelpers<IProduct>();

  const openCard = async (item: Partial<IProduct>) => {
    onUpdate(readOne(item._id!), item)
  }

  useFocusEffect(
    useCallback(() => {
      if (Boolean(route.params?._id)) {
        openCard({ _id: route.params._id, name: "Chargement..." });
      }
    }, [route])
  );

  return (
    <MainLayout
      header={(
        <ProductHeader>
          <CheckPermissions permissions={['dashboard::products.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un produit' />
          </CheckPermissions>
        </ProductHeader>
      )}>

      <ProductDeleteModal
        {...modal}
        onDelete={(product) => onDelete(deleteOne(product._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <ProductList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <ProductCreate />
            : <ProductUpdate
              product={product ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

